import { render, staticRenderFns } from "./GraduateConfigShowTeachTablePanel.vue?vue&type=template&id=27643c6f"
import script from "./GraduateConfigShowTeachTablePanel.vue?vue&type=script&lang=js"
export * from "./GraduateConfigShowTeachTablePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports